import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, Form, InputGroup, Collapse, Badge, Dropdown  } from 'react-bootstrap';
import { ChatDotsFill, Send, GearFill, X } from 'react-bootstrap-icons';
import { useAuth } from '../AuthContext';
import axios from 'axios';
import { getToken } from '../apiService';
import { Text } from 'react-native';
import popup_svg from '../img/dropdown.svg';

const ChatWidget = ({ applyId }) => {
  const { user } = useAuth();
  const [profile_email, setProfile] = useState(user?.email);
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [lastInput, setLastInput] = useState('');
  const [messages, setMessages] = useState([{ role: 'bot', message: 'How can I help you today?' }]);
  const [template_name, setTemplate_name] = useState('');
  const textareaRef = useRef(null);

  const emptyMessage_templates=['interview_prep_prompt','job_aicv_match_score_prompt','job_initialcv_match_score_prompt',];
  const apiServer = process.env.REACT_APP_API_SERVER_URL ?? '/api/';

  const scrollRef = useRef(null);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = async () => {
    if (!input.trim()) return;

    const userMessage = { role: 'user', message: input, template_name: template_name };
    setMessages(prev => [...prev, userMessage]);
    setInput('');

    const idToken = await getToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };

    try {
      // Calling your specific backend API
      // Spreads: add_role, add_cv, add_job, add_no_remarks
      const response =  applyId ?
        await axios.patch(apiServer+'ai_question/'+applyId, {message: input, template_name: template_name },{headers: headers})  :
        await axios.patch(apiServer+'ai_question_general/'+profile_email, {message: input,}, {headers: headers});

      setMessages(prev => [...prev, { role: 'bot', message: response.data.answer }]);
    } catch (error) {
      console.error(error);
      setMessages(prev => [...prev, { role: 'bot', message: 'Error connecting to service : '+error }]);
    }
  };

  const handleTemplate_nameChanged = (e) => {
    if( emptyMessage_templates.includes(e.target.value)){
      const text = e.target.options[e.target.selectedIndex].text;
      setInput(text);
    }
    setTemplate_name(e.target.value);
  }

const insertTextAtCursor = (insertedText) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    // Get current cursor position
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    // Build the new string
    const newText = input.substring(0, start) + insertedText + input.substring(end);

    setInput(newText);

    // Optional: Return focus to textarea and set cursor after inserted text
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + insertedText.length, start + insertedText.length);
    }, 0);
  };

  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
      {/* Floating Toggle Button */}
      {!isOpen && (
        <Button
          variant="primary"
          className="rounded-circle p-3 shadow-lg"
          onClick={() => setIsOpen(true)}
        >
          <ChatDotsFill size={24} />
        </Button>
      )}

      {/* Chat Window */}
      <Collapse in={isOpen}>
        <Card className="shadow-lg" style={{ width: '350px', maxHeight: '500px' }}>
          <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
            <strong>Be ready by AI Assistant</strong>
            <div>
              <Button variant="link" className="text-white p-0" onClick={() => setIsOpen(false)}>
                <X size={24} />
              </Button>
            </div>
          </Card.Header>

          <Card.Body style={{ overflowY: 'auto', height: '300px' }}>
            {messages.map((msg, i) => (
              <div key={i} className={`d-flex mb-2 ${msg.role === 'user' ? 'justify-content-end' : 'justify-content-start'}`}>
                <div className={`p-2 rounded ${msg.role === 'user' ? 'bg-primary text-white' : 'bg-light border'}`} style={{ maxWidth: '80%' }}>
                  <Text>{msg.message}</Text>
                </div>
              </div>
            ))}
            <div ref={scrollRef} />
          </Card.Body>

          <Card.Footer>
            <InputGroup>
              <Form.Control
                as="textarea" rows={3}
                ref={textareaRef}
                placeholder="Ask a question..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && !e.shiftKey && handleSend()}
              />
              <span>
              <Button variant="primary" onClick={handleSend}><Send /></Button><br/>
              <Dropdown align="end">
                      <Dropdown.Toggle variant="outline-secondary" id="dropdown-insert"> </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => insertTextAtCursor(" {{ apply.ai_gen_cv }} ")}>Your AI generated CV</Dropdown.Item>
                        <Dropdown.Item onClick={() => insertTextAtCursor(" {{ profile.initial_cv }} ")}>Your Initial CV</Dropdown.Item>
                        <Dropdown.Item onClick={() => insertTextAtCursor(" {{ job.company }} ")}>Company Name</Dropdown.Item>
                        <Dropdown.Item onClick={() => insertTextAtCursor(" {{ job.title }} ")}>Job Title</Dropdown.Item>
                        <Dropdown.Item onClick={() => insertTextAtCursor(" {{ job.description }} ")}>Job Description</Dropdown.Item>
                        <Dropdown.Item onClick={() => insertTextAtCursor(" {{ profile.detail.summary }} ")}>Your CV's summary section</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
              </span>
            </InputGroup>
            <Form.Select name="template_name" value={template_name} onChange={ handleTemplate_nameChanged } aria-label="Default select template" >
              <option value=''>(select template)</option>
              <option value='answer_basedon_job_cv_prompt'>Answer my question based on CV and job description</option>
              <option value='interview_prep_prompt'>How should I be prepare for interview?</option>
              <option value='job_aicv_match_score_prompt'>Match score my AI GEN CV with job description!</option>
              <option value='job_initialcv_match_score_prompt'>Match score my initial CV with job description!</option>
              <option value='email_answer_prep_prompt'>Answer this email I received!</option>
            </Form.Select>
          </Card.Footer>
        </Card>
      </Collapse>
    </div>
  );
};

export default ChatWidget;
